// Shared Framer Motion variants to unify animation language across sections.
// Respect reduced motion by allowing components to override y/scale externally if needed.

export const easeStandard = [0.16, 0.66, 0.45, 0.99];
export const easeEmphasized = [0.25, 0.8, 0.25, 1];

export const fadeInUp = (delay = 0, distance = 24) => ({
  hidden: { opacity: 0, y: distance },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, delay, ease: easeStandard } }
});

export const fadeIn = (delay = 0) => ({
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.55, delay, ease: easeStandard } }
});

export const scaleIn = (delay = 0) => ({
  hidden: { opacity: 0, scale: 0.9 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.55, delay, ease: easeEmphasized } }
});

export const staggerChildren = (stagger = 0.08, delayChildren = 0) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren: stagger,
      delayChildren
    }
  }
});

export const fadeInLeft = (delay = 0, distance = 40) => ({
  hidden: { opacity: 0, x: -distance },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, delay, ease: easeStandard } }
});

export const fadeInRight = (delay = 0, distance = 40) => ({
  hidden: { opacity: 0, x: distance },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, delay, ease: easeStandard } }
});

// Utility to choose left/right variant by boolean.
export const horizontalEntrance = (isEven, delay = 0) => (isEven ? fadeInRight(delay) : fadeInLeft(delay));
